<template>
  <CHeader with-subheader class="fixed-top">
    <CHeaderBrand class="pl-2 pl-md-5 mr-auto" to="/user">
      <div class="d-flex align-items-center">
        <img class="logo-custom pr-2 py-1" src="@/assets/logo.svg">
        <div class="text-black">
          <p class="font-weight-bold mb-0 h5 brand-title">MFU</p>
          <p class="font-weight-bold mb-0 brand-subtitle d-none d-sm-block">{{ $t('brand.maintenanceShort') }}</p>
        </div>
      </div>
    </CHeaderBrand>

    <CHeaderNav class="pr-2 pr-md-3 d-flex align-items-center ml-auto">
      <LanguageSwitcher class="mr-1 mr-md-2" />
      <div class="my-text-style profile-name pr-2 d-none d-md-block">
        {{ profile ? profile.name : '' }} {{ profile ? profile.surname : '' }}
      </div>
      <div class="my-text-style profile-name-mobile pr-2 d-md-none">
        {{ profile ? (profile.name.length > 8 ? profile.name.substring(0,8)+'..' : profile.name) : '' }}
      </div>
      <TheHeaderDropdownAccnt/>
    </CHeaderNav>
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'
import LanguageSwitcher from '@/components/common/LanguageSwitcher.vue'
import { mapGetters } from "vuex";

export default {
  name: 'TheHeader',
  components: {
    TheHeaderDropdownAccnt,
    LanguageSwitcher,
  },
  computed: {
    ...mapGetters("auth", ["profile", "role"])
  },
}
</script>

<style scoped>
/* Style เดิม */
.sidebar-below-header {
  top: 66px !important;
}

.my-text-style {
  font-family: 'Arial', sans-serif;
  color: #333333; 
  font-weight: bold; 
  line-height: 1.5; 
  letter-spacing: 0.75px;
  white-space: nowrap; /* ป้องกันชื่อขึ้นบรรทัดใหม่ */
}

/* --- 1. ขนาดปกติ (Desktop) --- */
.logo-custom { height: 50px; }
.brand-title { font-size: 1.25rem; }
.brand-subtitle { font-size: 1rem; }
.profile-name { font-size: 15px; display: block; }

/* --- 2. ขนาดมือถือ (Mobile: หน้าจอเล็กกว่า 768px) --- */
@media (max-width: 768px) {
  .logo-custom { height: 35px; }
  .brand-title { font-size: 1rem; line-height: 1.2; }
  .profile-name-mobile {
    font-size: 11px;
    font-weight: bold;
    color: #333333;
    max-width: 70px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

@media (max-width: 480px) {
  .brand-title { font-size: 0.9rem; }
}
</style>